
export default class CookieManager {

    static getCookie(name) {
        const regExp = new RegExp(`${name}=([^;]*)`);
        const cookie = document.cookie.match(regExp);

        return cookie && cookie[1] ? cookie[1] : null;
    }
    static setCookie(name, value, age = 36660000, forced = false) {
        if (!this.cookieAccepted && !forced) return;

        document.cookie = `${name}=${value};max-age=${!!value ? age : 0};`;
    }

    static get testerMode() {
        return  !!this.getCookie("testerMode");
    }
    static set testerMode(value) {
        this.setCookie("testerMode", value, 36660000);
    }

    static get cookieAccepted() {
        return  !!this.getCookie("cookieAccepted");
    }
    static set cookieAccepted(value) {
        this.setCookie("cookieAccepted", value, 36660000, true);
    }

    static get language() {
        return this.getCookie("playLanguage");
    }
    static set language(value) {
        this.setCookie("playLanguage", value, 86400);
    }

}

